import VoucherApi from '@api/voucher'
import {
  VOUCHER_LIST,
} from '../mutationTypes'
const state = {
  voucherList: [],
}

const getter = {}

const actions = {
  async fetchVoucherList({ commit }, payload) {
    const list = await VoucherApi.fetchVoucherList({
      page_size: 9999,
      client_id: payload.client_id,
    })
    commit(VOUCHER_LIST, list)
  }
}

const mutations = {
  [VOUCHER_LIST](state, list) {
    state.voucherList = list
  },
}

export default {
  namespaced: true,
  state,
  getter,
  actions,
  mutations,
}
